import React, { useMemo } from "react"
import { Outlet, useSearchParams } from "react-router-dom"
import { createMessengerEnvironment } from "../../RelayEnvironment"
import {
  RelayEnvironmentProvider,
} from "react-relay"

const GRAPHQLAPI_PATH = process.env.REACT_APP_GRAPHQLAPI_PATH

const MessengerLayout = () => {
  const [searchParams] = useSearchParams()
  const defaultToken = searchParams.get('token')
  const relayEnv = useMemo(() => {
    return createMessengerEnvironment({
      url: GRAPHQLAPI_PATH,
      token: defaultToken,
    })
  }, [defaultToken])

  const postMessageToSDK = (payload) => {
    let inIFrame
    try {
      inIFrame = window.self !== window.top
    } catch (e) {
      inIFrame = true
    }
    if (inIFrame) {
      window.parent.postMessage({
        source: "woztell-web-chat",
        payload,
      }, "*")
    }
  }

  return (
    <RelayEnvironmentProvider environment={relayEnv}>
      <Outlet
        context={{
          postMessageToSDK,
        }}
      />
    </RelayEnvironmentProvider>
  )
}


export default MessengerLayout